import { ChecklistCriteria, CriteriaInstance } from "types/Checklist";
import { CellTextParagraphs } from "types/WordChecklist";

export const useClipboardChecklistCriteriaGenerator = (
    criteriaInstance: CriteriaInstance,
    allCriteria: ChecklistCriteria[],
    numParagraphs: number,
    numParagraphColumns: number,
    cellTextToParagraphs: CellTextParagraphs[],
    color: string = "000000"
) => {
    const allRows = [];
    const criteria = criteriaInstance.checklistCriteriaId
        ? useGetCriteriaFromId(allCriteria, criteriaInstance.checklistCriteriaId)
        : undefined;

    if (criteria || criteriaInstance.isCustom) {
        const criteriaLabel =
            criteria?.label ?? criteriaInstance.labelOverride ?? "N/A";




        let label = document.createElement("td");
        label.style.border = "1px solid black";
        label.style.width = "auto";

        const labelSpan = document.createElement("span");
        labelSpan.innerText = criteriaLabel;

        if (criteriaInstance.ignore) {
            labelSpan.style.textDecoration = "line-through";
        }

        label.appendChild(labelSpan);




        for (const cellTextParagraphsInstance of cellTextToParagraphs) {
            const cellText = cellTextParagraphsInstance.text
                .replace(/\n/g, "") // Remove newline characters
                .toLowerCase() // Convert to lowercase
                .replace(/\s+/g, " ") // Replace multiple spaces with a single space
                .trim(); // Remove leading and trailing spaces

            const newCriteriaLabel = criteriaLabel
                .replace(/\n/g, "") // Remove newline characters
                .toLowerCase() // Convert to lowercase
                .replace(/\s+/g, " ") // Replace multiple spaces with a single space
                .trim(); // Remove leading and trailing spaces

            if (
                cellText.includes(newCriteriaLabel) ||
                newCriteriaLabel.includes(cellText)
            ) {

                // Clear the labrel innerhtml children
                label.innerHTML = "";

                for (const paragraph of cellTextParagraphsInstance.paragraphs) {
                    for (const token of paragraph.tokens) {

                        const tokenSpan = document.createElement("span");
                        tokenSpan.style.cssText = useConvertTokenToStyleFormatting(token.formatting, paragraph.formatting.alignment, paragraph.formatting.lineSpacing);
                        tokenSpan.innerText = token.text == "\u000b" ? "\n" : token.text;

                        if (criteriaInstance.ignore) {
                            tokenSpan.style.textDecoration = "line-through";
                        }


                        label.appendChild(tokenSpan);

                    }
                }
            }
        }

        const criteriaRow = document.createElement("tr");

        const bufferCell = document.createElement("td");
        bufferCell.style.width = "30px";
        bufferCell.style.border = "1px solid black";

        criteriaRow.appendChild(bufferCell);
        criteriaRow.appendChild(label);
        const scoreRow = document.createElement("tr");

        if (
            criteriaInstance.evaluationMethod == "paragraph" &&
            criteriaInstance.paragraphPositionsData &&
            criteriaInstance.paragraphPositionsData.length > 1
        ) {
            const numEarnedPointsParagraphs =
                criteriaInstance.paragraphPositionsData.length;

            let columnSpan = Math.floor(
                numParagraphColumns / numEarnedPointsParagraphs
            );
            let totalColumns = 0;
            let index = 0;

            const scoresWrapperCell = document.createElement("td");
            scoresWrapperCell.style.border = "1px solid black";
            scoresWrapperCell.style.textAlign = "center";
            scoresWrapperCell.style.verticalAlign = "middle";


            for (const paragraphPositionData of criteriaInstance.paragraphPositionsData) {
                const paragraphPoints =
                    paragraphPositionData.manualScore ?? paragraphPositionData.score ?? 0;
                totalColumns += columnSpan;

                // If the current key is the last keym and the total columns isn't yet equal to numParagraphs
                // Then we need to set columnSpan to the difference between numParagraphs and totalColumns
                if (
                    index == numEarnedPointsParagraphs - 1 &&
                    totalColumns != numParagraphColumns
                ) {
                    columnSpan += numParagraphColumns - totalColumns;
                }

                var scoreCellText = "0";

                if (paragraphPoints) {
                    scoreCellText = paragraphPoints.toString();
                }

                if (criteriaInstance.pointsPerInstance) {
                    scoreCellText += `/${criteriaInstance.pointsPerInstance}`;
                }


                const scoreCell = document.createElement("td");
                scoreCell.innerText = criteriaInstance.ignore != true ? scoreCellText : "";
                scoreCell.style.textAlign = "center";
                scoreCell.style.border = "1px solid black";
                scoreCell.style.width = `${150 / numParagraphColumns}px`;

                criteriaRow.appendChild(scoreCell);


                index++;
            }


            // criteriaRow.appendChild(scoresWrapperCell);
        } else {
            var scoreCellText = "";

            if (!criteriaInstance.earnedPoints) {
                criteriaInstance.earnedPoints = 0;
            }

            if (criteria && criteria.showPointsPlus) {
                scoreCellText = `+${criteriaInstance.earnedPoints.toString()}`;
            } else if (
                criteriaInstance.earnedPoints != 0 ||
                criteriaInstance.maxPoints != undefined
            ) {
                scoreCellText = criteriaInstance.earnedPoints.toString();
            }

            if (criteriaInstance.maxPoints) {
                scoreCellText += `/${criteriaInstance.maxPoints}`;
            }

            const scoreCell = document.createElement("td");
            scoreCell.innerText = criteriaInstance.ignore != true ? scoreCellText : "";
            scoreCell.style.textAlign = "center";
            scoreCell.style.border = "1px solid black";
            scoreCell.setAttribute("colspan", numParagraphColumns.toString());
            scoreCell.style.width = "150px";

            criteriaRow.appendChild(scoreCell);



        }

        allRows.push(criteriaRow);
    }

    return allRows;
};